var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5704 8.76535C10.1983 8.39035 9.29685 7.84309 8.85951 7.62254C8.28998 7.33566 8.2431 7.31223 7.79545 7.64481C7.49685 7.86676 7.29834 8.06504 6.94888 7.99051C6.59943 7.91598 5.84006 7.49574 5.17513 6.83293C4.51021 6.17012 4.0656 5.38871 3.99084 5.04043C3.91607 4.69215 4.11763 4.49598 4.33748 4.19668C4.64732 3.7748 4.62388 3.70449 4.35904 3.13496C4.15256 2.69199 3.58935 1.79902 3.21295 1.42871C2.81029 1.03098 2.81029 1.10129 2.55084 1.2091C2.3396 1.29796 2.13696 1.40599 1.94545 1.53184C1.57045 1.78098 1.36232 1.98793 1.21677 2.29894C1.07123 2.60996 1.00584 3.3391 1.75748 4.70457C2.50912 6.07004 3.03646 6.76824 4.12795 7.85668C5.21943 8.94512 6.05873 9.53035 7.28568 10.2185C8.80349 11.0686 9.38568 10.9029 9.69764 10.7575C10.0096 10.6122 10.2175 10.406 10.4671 10.031C10.5933 9.83978 10.7015 9.63737 10.7905 9.42629C10.8986 9.16777 10.9689 9.16777 10.5704 8.76535Z",
    stroke: "#04236B",
    strokeWidth: 0.631027,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.a312d7dbef8b9db080292c08fa8b62ff.svg";
export { ForwardRef as ReactComponent };